import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/Common.css"

<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>


    {/* Second ToastContainer with different styling */}
    <ToastContainer
      // className="custom-toast-container-2"
      // toastClassName={() =>
      //   "relative row px-3 py-2 rounded cursor-pointer bg-white shadow-lg items-center no-icon" // added no-icon class
      // }
      // bodyClassName={() => "text-black text-base font-normal"}

      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={true}
      closeButton={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover

    />
    <App />

  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
